import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { MultiPolygon } from '../models/multiPolygon';
import { Ranking } from '../models/ranking';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { PriorityGroupsComponent } from '../priority-groups/priority-groups.component';
import { FarmManagementService } from '../services/farm-management.service';
import { MappingService } from '../services/mapping.service';
import { Base } from '../services/base';

@Component({
    selector: 'app-rankings',
    templateUrl: './rankings.component.html',
    styleUrls: ['./rankings.component.css'],
    standalone: false
})
export class RankingsComponent implements OnInit {

  rankings: Ranking[] = [];
  activeSeason;
  cropType;
  activeId = -1;

  polygons: any[] = [];
  polygonCoords = [];
  unsortedPolygons = [];

  constructor(
    private router: Router,
    private _bottomSheetRef: MatBottomSheetRef<PriorityGroupsComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public base: Base,
    public farmManagementService: FarmManagementService,
    public mappingService: MappingService,
    public nav: NavBarComponent
  ) {
    this.nav.toggleLoading(false);
    this.rankings = this.data.rankings;
    this.activeSeason = this.data.activeSeason
    this.cropType = this.data.cropType;
  }

  getStatus(ranking: Ranking) {
    if (ranking.flagged) {
      return "Attention Required";
    } else {
      if (ranking.uncalculated) {
        return "No NDVI image available for calculation. Field not calculated";
      } else {
        return "NDVI index in range";
      }
    }
  }

  getIcon(ranking: Ranking) {
    if (ranking.flagged) {
      return "info";
    } else {
      if (ranking.uncalculated) {
        return "";
      } else {
        return "check_circle";
      }
    }
  }

  getIconClass(ranking: Ranking) {
    if (ranking.flagged) {
      return "info";
    } else {
      if (ranking.uncalculated) {
        return "";
      } else {
        return "check_circle";
      }
    }
  }

  getRankingIcon(ranking: Ranking) {
    if (ranking.ranking < ranking.previousRanking) {
      return "arrow_upward";
    } else if (ranking.ranking > ranking.previousRanking) {
      return "arrow_downward";
    }
  }

  onCloseClick() {
    this._bottomSheetRef.dismiss();
  }

  rankingClick(ranking: Ranking) {
    this.farmManagementService.getFarmPolygon(ranking.farmId).subscribe((fields) => {
      let currectField = 0;
      let polygonHoles = [];
      let holeCounter = 0;
      let fieldCounter = 0;
      let existingPolygon: MultiPolygon;
      fields.forEach(field => {
        this.mappingService.getFieldSize(field.id).subscribe((fieldsize) => {
          // @ts-ignore
          var coordinates = field.boundry.features[0].geometry.coordinates;
          let fieldPolygon = {
            coords: coordinates,
            fieldId: field.id,
            fieldName: field.name
          }
          this.polygonCoords.push(fieldPolygon);

          coordinates.forEach(coordinate => {
            if (coordinate.length > 1) {
              for (let i = 0; i < coordinate.length; i++) {
              }
            }
            let polygon: google.maps.LatLngLiteral[] = [];
            coordinate.forEach(coord => {
              let latLngArray = coord as []
              if (coordinate[0][0].length > 1) {
                polygon = [];
              }
              if (latLngArray.length > 2) {
                latLngArray.forEach(latLng => {
                  let point = {
                    lat: Number(latLng[1]),
                    lng: Number(latLng[0]),
                  }

                  polygon.push(point);
                })
              } else {
                let point1 = {
                  lat: Number(coord[1]),
                  lng: Number(coord[0])
                }
                polygon.push(point1);
              }
              if (coordinate[0][0].length > 1) {
                let fieldPolygon;

                if (currectField != field.id) {
                  currectField = field.id;
                  polygonHoles = [];
                  holeCounter = 0;
                } else {
                  holeCounter++;
                }

                existingPolygon = this.polygons.find(x => x.id == field.id)

                if (existingPolygon != null) {
                  if (holeCounter == 1) {
                    polygonHoles.unshift(existingPolygon.points);
                  }
                  polygonHoles.push(polygon);
                  fieldPolygon = {
                    id: field.id,
                    points: polygonHoles,
                    size: fieldsize.size,
                    fieldName: field.name,
                    changed: false
                  }
                  this.polygons.splice(this.polygons.indexOf(existingPolygon), 1);
                } else {
                  fieldPolygon = {
                    id: field.id,
                    points: polygon,
                    size: fieldsize.size,
                    fieldName: field.name,
                    changed: false
                  }
                }
                this.polygons.push(fieldPolygon);
              }
            });

            let fieldPolygon;

            if (currectField != field.id) {
              currectField = field.id;
              polygonHoles = [];
              holeCounter = 0;
            } else {
              holeCounter++;
            }

            existingPolygon = this.polygons.find(x => x.id == field.id);

            if (existingPolygon != null) {
              if (holeCounter == 1) {
                polygonHoles.unshift(existingPolygon.points);
              }
              polygonHoles.push(polygon);
              fieldPolygon = {
                id: field.id,
                points: polygonHoles,
                size: fieldsize.size,
                fieldName: field.name,
                changed: false
              }
              this.polygons.splice(this.polygons.indexOf(existingPolygon), 1);
            } else {
              fieldPolygon = {
                id: field.id,
                points: polygon,
                size: fieldsize.size,
                fieldName: field.name,
                changed: false
              }
            }
            this.polygons.push(fieldPolygon);
          });

          fieldCounter++;

          let fieldPolygons = [];
          if (fields.length == fieldCounter) {
            // for (let i = 0; i < this.polygons.length; i++) {
            this.polygons.forEach(poly => {
              if (poly.id == ranking.fieldId) {
                fieldPolygons.push(poly.points);
                let overlayedAnalysis = [];
                let images = [];
                this.base.setAnalysis(overlayedAnalysis, images, fieldPolygons, this.polygons);
                this.router.navigate(['/field'], { state: { id: ranking.fieldId, farmId: ranking.farmId, farmName: ranking.farmName } });
              }
            })
          }
        })
      })
      this.unsortedPolygons = [];
    })
    this._bottomSheetRef.dismiss();
  }

  ngOnInit(): void {
  }

}
